import * as constants from './constants';

export const getBarcodeManufacturers = (payload) => ({ type: constants.GET_BARCODE_MANUFACTURERS, payload });
export const getBarcodeManufacturersSuccess = (payload) => ({
  type: constants.GET_BARCODE_MANUFACTURERS_SUCCESS,
  payload,
});
export const getBarcodeManufacturerssError = (payload) => ({
  type: constants.GET_BARCODE_MANUFACTURERS_ERROR,
  payload,
});

export const resetBarcodeManufacturers = () => ({ type: constants.RESET_BARCODE_MANUFACTURERS });
